import Vue from 'vue';
import { Loading, MessageBox } from 'element-ui';


/** 调用屏幕加载 */
Vue.prototype.startloding = info => {
  Vue.prototype.ELloding = Loading.service({
    lock: true,
    text: info || '正在查询...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  });
};

Vue.prototype.closeLoding = () => {
  Vue.prototype.ELloding.close();
};

/** 调用用户确认操作窗口 */

Vue.prototype.confirmDialog = info => new Promise((resolve, reject) => {
  MessageBox.confirm(info, '提示', {
    type: 'warning',
  })
    .then(() => {
      resolve();
    })
    .catch(() => {
      reject();
    });
});

/** 进行表单校验 */

Vue.prototype.validateForms = ref => new Promise(resolve => {
  ref.validate(valid => {
    resolve(valid);
  });
});

/** 转行树型结构 */
/**
   *
   * @param {*} key 目标索引
   * @param {*} parentKey 夫级索引
   * @param {*} data 数据源
   * @description 将数据转换为树形结构
   */
Vue.prototype.data2TreeData = (key, parentKey, data) => {
  data.forEach(ele => {
    const parentId = ele[parentKey];
    if (!parentId) {
      // 是根元素的hua ,不做任何操作,如果是正常的for-i循环,可以直接continue.
    } else {
      // 如果ele是子元素的话 ,把ele扔到他的父亲的child数组中.\
      data.forEach(d => {
        if (Number(d[key]) === Number(parentId)) {
          const childArray = d.children || [];
          childArray.push(ele);
          // eslint-disable-next-line no-param-reassign
          d.children = childArray;
        }
      });
    }
  });
  console.log(data.filter(ele => !ele.parentId));
  // 去除重复元素
  return data.filter(ele => !ele.parentId);
};


/** 获取当前月的第一天 */

Vue.prototype.getCurrentMonthFirst = () => {
  const date = new Date();
  date.setDate(1);
  let month = parseInt(date.getMonth() + 1, 10);
  let day = date.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }
  return `${date.getFullYear()}-${month}-${day}`;
};


/** 获取当前月的最后一天 */

Vue.prototype.getCurrentMonthLast = () => {
  const date = new Date();
  const currentMonth = date.getMonth();
  const nextMonth = currentMonth + 1;
  const nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
  const oneDay = 1000 * 60 * 60 * 24;
  const lastTime = new Date(nextMonthFirstDay - oneDay);
  let month = parseInt(lastTime.getMonth() + 1, 10);
  let day = lastTime.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }
  return `${date.getFullYear()}-${month}-${day}`;
};
